<p *ngIf="!!showError" class='custom-invalid-feedback {{customClass}}' [innerHtml]="error"></p>